// extracted by mini-css-extract-plugin
module.exports = {"profile__spheres":"Portrait_profile__spheres__2GBFO","banner":"Portrait_banner__1g0P0","profile__portrait__img":"Portrait_profile__portrait__img__1Yx_A"};